import { GridIcon } from '../icons/grid';
import { ListIcon } from '../icons/list';
import { GearIcon } from '../icons/gear';

export function Toolbar({ openFilters }) {
  return (
    <div className={`map-search__toolbar`}>
      <a
        className={`map-search__toolbar-item map-search__toolbar-item_type_grid`}
        href={`/search${location.search}`}
      >
        <GridIcon />
        Grid
      </a>

      <a
        className={`map-search__toolbar-item map-search__toolbar-item_type_list`}
        href={`/search${location.search}`}
      >
        <ListIcon />
        List
      </a>

      <div
        className={`map-search__toolbar-item map-search__toolbar-item_type_filters`}
        onClick={openFilters}
      >
        <GearIcon />
        Filters
      </div>
    </div>
  );
}
